export default __webpack_public_path__ + "media/images/svg/pale-fb-icon-round-0e391e89c2720654b5b7955e9d376ba6.svg";